import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import HelpIcon from '@mui/icons-material/Help';

const HelpButton = ({ onClick }) => (
  <IconButton
    onClick={onClick}
    sx={{
      padding: 0,
      height: 'auto',
      width: 'auto',
      marginLeft: 'auto',
      marginRight: 15,
    }}
    size="large"
  >
    <HelpIcon className="white" />
  </IconButton>
);

HelpButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default HelpButton;
